__turbopack_context__.v({
  "blockDownloadList": "BlockDownloadList-module-scss-module__kR1vja__blockDownloadList",
  "eyebrow": "BlockDownloadList-module-scss-module__kR1vja__eyebrow",
  "inner": "BlockDownloadList-module-scss-module__kR1vja__inner",
  "list": "BlockDownloadList-module-scss-module__kR1vja__list",
  "listItem": "BlockDownloadList-module-scss-module__kR1vja__listItem",
});
